module.exports = __webpack_public_path__ + "static/media/ChristianaGarcia.562ea5e8.jpg";